export default "__VITE_ASSET__Drt0d9oY__"